/*
  dp-variant-auswahl.js — eigene Variantenauswahl für den Connector-Konfigurator.

  Der App-Block zeigt alle Varianten, die der Katalog zu einem Produkt kennt; die App kann
  einzelne nicht ausblenden. Dieses Skript hüllt window.fetch und filtert nur die Antwort von
  GET …/variants/product/<dp-id> auf die erlaubten flyer_variant_ids. Alles andere (Versand,
  Aufträge, Upload) geht unverändert durch. Erster Einsatz: Adventskalender ohne die Varianten
  mit Mindestmenge 60/100 und ohne Füllung ohne Nährwerttabelle.

  Konfiguration: data-dp-auswahl am eigenen <script>-Tag (Section-Einstellung variant_auswahl
  in dp-product-main), Format „<dp-id>:<flyer_variant_id>,<…>;<dp-id>:…“.
  Not-Aus: Einstellung leeren – dann wird nichts installiert. Bliebe nach dem Filtern keine
  Variante übrig, kommt die Originalantwort zurück (nie ein leerer Konfigurator).

  Läuft als Modul-Skript (wie alle Assets hier, assets/package.json) und damit vor
  DOMContentLoaded, also vor dem ersten Varianten-Abruf des Connectors (der startet erst bei
  DOMContentLoaded). Reine Helfer sind exportiert (tests/designer/dp-variant-auswahl.test.mjs).
*/
export function parseAuswahl(text) {
  const map = new Map();
  String(text || '').split(';').forEach(function (teil) {
    const i = teil.indexOf(':');
    if (i < 0) return;
    const gruppe = teil.slice(0, i).trim();
    if (!/^\d+$/.test(gruppe)) return;
    const ids = teil.slice(i + 1).split(',').map(function (s) { return s.trim(); }).filter(function (s) { return /^\d+$/.test(s); });
    if (ids.length) map.set(gruppe, new Set(ids));
  });
  return map;
}

export function gruppeAusUrl(url) {
  const m = /\/variants\/product\/(\d+)(?:[?#]|$)/.exec(String(url || ''));
  return m ? m[1] : null;
}

export function filtereVarianten(payload, erlaubt) {
  if (!payload || !Array.isArray(payload.data)) return payload;
  const data = payload.data.filter(function (v) { return v && erlaubt.has(String(v.flyer_variant_id)); });
  if (!data.length) return payload;
  return Object.assign({}, payload, { data: data });
}

export function installiere(win, auswahl) {
  if (!win || typeof win.fetch !== 'function' || !auswahl || !auswahl.size) return;
  if (win.fetch.__dpVariantAuswahl) return;
  const original = win.fetch;
  const gehuellt = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url);
    const gruppe = gruppeAusUrl(url);
    const erlaubt = gruppe && auswahl.get(gruppe);
    const antwort = original.call(win, input, init);
    if (!erlaubt) return antwort;
    return antwort.then(function (res) {
      if (!res || !res.ok) return res;
      return res.clone().json().then(function (json) {
        const gefiltert = filtereVarianten(json, erlaubt);
        if (gefiltert === json) return res;
        return new Response(JSON.stringify(gefiltert), { status: res.status, statusText: res.statusText, headers: res.headers });
      }, function () { return res; });
    });
  };
  gehuellt.__dpVariantAuswahl = true;
  win.fetch = gehuellt;
}

if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  const tag = document.querySelector('script[data-dp-auswahl]');
  if (tag) installiere(window, parseAuswahl(tag.getAttribute('data-dp-auswahl')));
}
